
const LuaModule = {
    postRun: [
        // text_changed
    ],
    print: function(text: string) {
        if (arguments.length > 1) text = Array.prototype.slice.call(arguments).join(' ');
        console.log(text);
    },
    printErr: function(text: string) {
        if (arguments.length > 1) text = Array.prototype.slice.call(arguments).join(' ');
        console.error(text);
    }
};

export default LuaModule;